module.exports = __webpack_public_path__ + "img/cheese-swiss.fff6fefa.svg";